export const sg3YearlyChecklistLicenseeFormMap = {
    Audit: [
        {
            id: "audit-q1",
            question: "Has a suitably qualified auditor been retained to conduct the audit?",
        },
        {
            id: "audit-q2",
            question:
                "Has the auditor been provided with advice of this year’s requirements of the Director-General in relation to the audit?",
        },
        {
            id: "audit-q3",
            question:
                "Has the auditor been advised when the audit report is required to be provided to the Director-General? (Normally the 30th September each year)",
        },
        {
            id: "audit-q4",
            question: "Has the Director-General been provided with the audit report?",
        },
    ],
    "Unclaimed Money": [
        {
            id: "unclaimed-money-q1",
            question:
                "Has a complete review of the trust account balances been prepared in January noting any balance that is two (2) years or older as at the end of the preceding month?",
        },
        {
            id: "unclaimed-money-q2",
            question: "Has the Director-General been provided with a notice in the approved form prior to 31 January advising of any balance two (2) years or older as at the end of the previous month?"
        }
    ],
};
